import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { useConfig } from './hooks/useConfig';
import { DashboardLayout } from './layouts/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import TaxesPage from './pages/TaxesPage';
import UsersPage from './pages/UsersPage';
import AccountsPage from './pages/AccountsPage';
import TransactionsPage from './pages/TransactionsPage';
import DocumentsPage from './pages/DocumentsPage';
import CashFlowPage from './pages/CashFlowPage';
import DREPage from './pages/DREPage';
import ProjectionPage from './pages/ProjectionPage';
import CashflowForecastPage from './pages/CashflowForecastPage';
import ReportsPage from './pages/ReportsPage';
import EmployeesPage from './pages/EmployeesPage';
import ImportPage from './pages/ImportPage';
import DedupReviewPage from './pages/DedupReviewPage';
import ConciliacaoPage from './pages/ConciliacaoPage';
import ContasPagarPage from './pages/ContasPagarPage';
import ContasReceberPage from './pages/ContasReceberPage';
import PeriodicasPage from './pages/PeriodicasPage';
import ClientesPage from './pages/ClientesPage';
import NotasFiscaisPage from './pages/NotasFiscaisPage';
import PendentesPage from './pages/PendentesPage';
import TarefasPage from './pages/TarefasPage';
import BancoMCPPage from './pages/BancoMCPPage';
import BancoMCPReconciliacaoPage from './pages/BancoMCPReconciliacaoPage';
import NotasFiscaisFornecedorPage from './pages/NotasFiscaisFornecedorPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function FeatureRoute({ feature, children }: { feature: string; children: React.ReactNode }) {
  const { hasFeature } = useConfig();
  if (!hasFeature(feature)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function ExtratoRedirect() {
  const location = useLocation();
  return <Navigate to={`/lancamentos${location.search}`} replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/contas" element={<AccountsPage />} />
        <Route path="/lancamentos" element={<TransactionsPage />} />
        <Route path="/documentos" element={<DocumentsPage />} />
        <Route path="/fluxo-de-caixa" element={<CashFlowPage />} />
        <Route path="/dre" element={<DREPage />} />
        <Route path="/projecao" element={<ProjectionPage />} />
        <Route path="/fluxo-projetado" element={<CashflowForecastPage />} />
        <Route path="/extrato" element={<ExtratoRedirect />} />
        <Route path="/contas-pagar" element={<FeatureRoute feature="contas-pagar"><ContasPagarPage /></FeatureRoute>} />
        <Route path="/contas-receber" element={<FeatureRoute feature="contas-receber"><ContasReceberPage /></FeatureRoute>} />
        <Route path="/impostos" element={<FeatureRoute feature="impostos"><TaxesPage /></FeatureRoute>} />
        <Route path="/funcionarios" element={<FeatureRoute feature="funcionarios"><EmployeesPage /></FeatureRoute>} />
        <Route path="/importar" element={<ImportPage />} />
        <Route path="/duplicatas" element={<DedupReviewPage />} />
        <Route path="/conciliacao" element={<ConciliacaoPage />} />
        <Route path="/relatorios" element={<ReportsPage />} />
        <Route path="/contas-periodicas" element={<PeriodicasPage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/notas-fiscais" element={<NotasFiscaisPage />} />
        <Route path="/pendentes" element={<PendentesPage />} />
        <Route path="/tarefas" element={<TarefasPage />} />
        <Route path="/banco-mcp" element={<BancoMCPPage />} />
        <Route path="/banco-mcp/reconciliacao" element={<BancoMCPReconciliacaoPage />} />
        <Route path="/notas-fiscais-fornecedor" element={<NotasFiscaisFornecedorPage />} />
      </Route>
    </Routes>
  );
}

export default App;
